class CustomError extends Error {
  protected _type!: string;

  get type(): string {
    return this._type;
  }
}

export default CustomError;
